import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { pdpTexts } from 'i18n';
import { RelatedArea } from 'constants/pdp';

interface RelatedAreaOption {
  id: RelatedArea;
  name: string;
  color: string;
}

const useRelatedAreaOptions = (): RelatedAreaOption[] => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => [
      {
        id: RelatedArea.EXPERTISE,
        name: formatMessage(pdpTexts.expertise),
        color: '#b9dcff',
      },
      {
        id: RelatedArea.CONSULTANCY,
        name: formatMessage(pdpTexts.consultancy),
        color: '#ffe9b1',
      },
      {
        id: RelatedArea.LEADERSHIP,
        name: formatMessage(pdpTexts.leadership),
        color: '#a4ece4',
      },
    ],
    [formatMessage],
  );
};

export default useRelatedAreaOptions;
